import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=6222d42a&scoped=true&"
import script from "./VideoCall.vue?vue&type=script&setup=true&lang=js&"
export * from "./VideoCall.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=6222d42a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222d42a",
  null
  
)

export default component.exports